import React, { FC, useEffect } from "react";
import { makeStyles, Theme, createStyles } from "@material-ui/core/styles";
import Modal from "@material-ui/core/Modal";
import { Grid, TableBody, TableCell, TableRow, Typography } from "@material-ui/core";
import InfoTip from "../../common/InfoTip";
import { postRequest } from "../../../apis/axiosAction";
import { DateTime } from "luxon";
import { userLogging } from "../../../apis/userLog";

function getModalStyle() {
  return {
    top: "5%",
    left: "5%",
  };
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    paper: {
      position: "absolute",
      top: "5%",
      width: "50%",
      backgroundColor: theme.palette.background.paper,
      border: "2px solid #000",
      boxShadow: theme.shadows[5],
      padding: theme.spacing(2, 4, 3),
    },
  })
);

const TenpoCheckModalSagyoWariate: FC<{
  tenpoCode: string;
  taskId: string;
  tenpoName: string;
}> = ({tenpoCode, taskId, tenpoName}) => {
  const classes = useStyles();
  const [modalStyle] = React.useState(getModalStyle);
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => {
    setOpen(true);
    userLogging("店舗確認表", "作業実施状況サマリ", tenpoName + " # " + title);
  };
  const [title, setTitle] = React.useState("");
  const [renkeiDataList, setRenkeiDataList] = React.useState<any[]>([]);

  // 検索実行処理
  useEffect(() => {
    let storeTaskList = [{store_id: tenpoCode, task_id: taskId}];
    
    const apiParams = {
      store_task_list: storeTaskList
    };
    const url = process.env.REACT_APP_API_URL_J11SPB22 + "tenpocheck/workProgress";
    postRequest(url, apiParams)
      .then((res) => {
        let dataList: any[] = res.data.dataList;
        if (dataList) {
          for (let i = 0; i < dataList.length; i++) {
            
            let datajsList: any = dataList[i];
            let preStoreTaskList: any = JSON.parse(datajsList.store_task_list);
            let taskName = "";
            let responsTaskList: any[] = [];
            let storeTaskList: any[] = preStoreTaskList.store_task_list;
            for (let j = 0; j < storeTaskList.length; j++) {
              taskName = storeTaskList[j].task_name;
              let assignedTaskList: any[] = storeTaskList[j].assigned_task_list;
              for (let assignedTask of assignedTaskList) {
                let execDateTime = DateTime.fromFormat(assignedTask.exec_date, "yyyyMMdd");
                let weekDayArray = ["月", "火", "水", "木", "金", "土", "日"];
                let execDate = execDateTime.toFormat("MM月dd日") + 
                  "(" + weekDayArray[execDateTime.weekday - 1] + ")";
                
                let execTimeHH = assignedTask.exec_time_box + "時台";
                if (!assignedTask.exec_time_box) {
                  execTimeHH = "定時作業"
                }
                let execTimeBox = execTimeHH;
                let effortMin = assignedTask.task_man_effort_min + "分";
                let isFinished = assignedTask.is_finished;
                let taskMap = {execDate, execTimeBox, effortMin, isFinished}
                responsTaskList.push(taskMap);
              }
            }
            setTitle(taskName);
            setRenkeiDataList(responsTaskList);
          }
        }
      })
  }, [tenpoCode, taskId]);

  function countText(text: string) {
    let count = 0;
    if (text) {
      for (let i = 0; i < text.length; i++) {
        let c = text.charCodeAt(i);
        if (
          (c >= 0x0 && c < 0x81) ||
          c === 0xf8f0 ||
          (c >= 0xff61 && c < 0xffa0) ||
          (c >= 0xf8f1 && c < 0xf8f4)
        ) {
          count += 1;
        } else {
          count += 2;
        }
      }
    }
    return count;
  }

  const createTable = () => {
    let resultList: any[] = [];
    for (let renkei of renkeiDataList) {
      let douitubiFlg = false;
      for (let i = 0; i < resultList.length; i++) {
        if (resultList[i].execDate === renkei.execDate) {
          let resultDateBetsuList: any[] = resultList[i].dateList;
          resultDateBetsuList.push(renkei);
          resultList[i]["dateList"] = resultDateBetsuList;
          douitubiFlg = true;
          break;
        }
      }
      if (!douitubiFlg) {
        let dateList = [];
        dateList.push(renkei);
        let resultMap = { execDate: renkei.execDate, dateList: dateList };
        resultList.push(resultMap);
      }
    }

    return (
      <Grid>
        <Grid container justify="center" alignItems="center">
            <Typography variant="h4" >{title}</Typography>
        </Grid>
        <Grid container justify="center" alignItems="center">
            <TableBody>
                <TableCell></TableCell>
                <TableCell>割当時刻</TableCell>
                <TableCell>所要時間</TableCell>
                <TableCell>前週実施有無</TableCell>
        {resultList.map((result: any) =>
          result.dateList.map((row: any, index: number) => (
              <TableRow>
                {index === 0 ? (
                  <TableCell rowSpan={result.dateList.length} style={{backgroundColor:"#d8e8e6"}}>
                    {row.execDate}
                  </TableCell>
                ) : (
                  ""
                )}
                <TableCell style={{textAlign:"center"}}>{row.execTimeBox}</TableCell>
                <TableCell style={{textAlign:"center"}}>{row.effortMin}</TableCell>
                <TableCell style={{textAlign:"center"}}>{row.isFinished === "1" ? "◯" : "×"}</TableCell>
              </TableRow>
          ))
        )}
            </TableBody>
        </Grid>
      </Grid>
    );
  };
  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Grid container onClick={handleOpen}>
        <Typography
          style={countText(title) > 180 ? { fontSize: "0.78em" } : {}}
        >
          <InfoTip
            iconType="info"
            infoText=""
            placement="top"
            noTitleFlg={true}
          />
        </Typography>
      </Grid>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="simple-modal-title"
        aria-describedby="simple-modal-description"
        style={{ height: "95vh", overflowY: "auto" }}
      >
        <div style={modalStyle} className={classes.paper}>
          {renkeiDataList ? createTable() : ""}
        </div>
      </Modal>
    </>
  );
};
export default TenpoCheckModalSagyoWariate;
